import artysciUsmiechu from 'assets/img/logos/artysci_usmiechu.webp';
import demedStomatologia from 'assets/img/logos/demed_stomatologia.webp';
import dent from 'assets/img/logos/dent.webp';
import dentaLineDabkowscy from 'assets/img/logos/denta_line_dabkowscy.webp';
import dentalFraternity from 'assets/img/logos/dental_fraternity.webp';
import dentalove from 'assets/img/logos/dentalove.webp';
import dentaurus from 'assets/img/logos/dentaurus.webp';
import dorotowskaDentalClinic from 'assets/img/logos/dorotowska_dental_clinic.webp';
import faceClinic from 'assets/img/logos/face_clinic.webp';
import identical from 'assets/img/logos/identical.webp';
import kissDentalCare from 'assets/img/logos/kiss_dental_care.webp';
import maszewskiMedicine from 'assets/img/logos/maszewski_medicine.webp';
import medicadent from 'assets/img/logos/medicadent.webp';
import noirDentalClinic from 'assets/img/logos/noir_dental_clinic.webp';
import oravelleClinic from 'assets/img/logos/oravelle_clinic.webp';
import orident from 'assets/img/logos/orident.webp';
import platinumClinics from 'assets/img/logos/platinum_clinics.webp';
import proOrtodont from 'assets/img/logos/pro_ortodont.webp';
import smileInstitute from 'assets/img/logos/smile_institute.webp';
import szpitalDworska from 'assets/img/logos/szpital_dworska.webp';
import zyrafaZebala from 'assets/img/logos/zyrafa_zebala.webp';

// tone: how the logo is flattened to monochrome ('wb' – on white, 'inv' – on dark)
export const LOGOS = [
  { src: orident, alt: 'Orident' },
  { src: dorotowskaDentalClinic, alt: 'Dorotowska Dental Clinic', tone: 'wb' },
  { src: platinumClinics, alt: 'Platinum Clinics' },
  { src: medicadent, alt: 'Medicadent' },
  { src: faceClinic, alt: 'Face Clinic' },
  { src: proOrtodont, alt: 'Pro Ortodont' },
  { src: dentaurus, alt: 'Dentaurus' },
  { src: identical, alt: 'iDentical' },
  { src: zyrafaZebala, alt: 'Żyrafa Zębala' },
  { src: szpitalDworska, alt: 'Szpital Dworska' },
  { src: dent, alt: 'Dent', tone: 'inv' },
  { src: dentalFraternity, alt: 'Dental Fraternity' },
  { src: demedStomatologia, alt: 'Demed Stomatologia', tone: 'wb' },
  { src: dentaLineDabkowscy, alt: 'Denta Line Dąbkowscy', tone: 'inv' },
  { src: artysciUsmiechu, alt: 'Artyści Uśmiechu', tone: 'inv' },
  { src: dentalove, alt: 'Dentalove', tone: 'wb' },
  { src: oravelleClinic, alt: 'Oravelle Clinic' },
  { src: maszewskiMedicine, alt: 'Maszewski Medicine' },
  { src: noirDentalClinic, alt: 'Noir Dental Clinic' },
  { src: kissDentalCare, alt: 'Kiss Dental Care' },
  { src: smileInstitute, alt: 'Smile Institute' }
];
